<div class="free-date-banner"
     [class.middle]="displayMode === 'middle'"
     [class.short]="displayMode === 'short'">
  <ng-template [ngIf]="isTeacher" [ngIfElse]="student">
    <div class="content">
      <h2 class="title bold">{{ 'library.free-date-banner.title' | customLocale }}</h2>
      <p class="text normal">{{ 'library.free-date-banner.text-part1' | customLocale }}
        <a [routerLink]="'/' + routes.classes + '/create'"
          class="link bold">{{ 'library.free-date-banner.text-part2' | customLocale }}</a>
        {{ 'library.free-date-banner.text-part3' | customLocale }}</p>
      <a [routerLink]="'/' + routes.classes + '/create'" class="action">
        <button class="action-btn normal">{{ 'library.free-date-banner.action' | customLocale }}</button>
      </a>
    </div>
  </ng-template>

  <ng-template #student>
    <div class="content student">
      <h2 class="title bold">{{ 'library.free-date-banner.title2' | customLocale }}</h2>
      <p class="text normal">{{ 'library.free-date-banner.text2' | customLocale }}</p>
      <a [routerLink]="'/' + routes.tutors" class="action">
        <button class="action-btn normal">{{ 'library.free-date-banner.action2' | customLocale }}</button>
      </a>
    </div>
  </ng-template>
</div>
